(() => {
  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
  const finePointer = window.matchMedia('(hover: hover) and (pointer: fine)');

  const setRevealDelays = () => {
    const groups = document.querySelectorAll(
      '.mm-form-grid, .mm-scents__grid, .mm-gateways__grid, .mm-process__steps, .mm-after__uses'
    );

    groups.forEach((group) => {
      Array.from(group.children).forEach((item, index) => {
        if (!item.classList.contains('mm-reveal')) return;
        item.style.setProperty('--mm-reveal-delay', `${Math.min(index * 70, 280)}ms`);
      });
    });
  };

  const observeReveals = () => {
    const revealItems = document.querySelectorAll('.mm-reveal');

    if (reduceMotion.matches || !('IntersectionObserver' in window)) {
      revealItems.forEach((item) => item.classList.add('is-visible'));
      return;
    }

    if (!window.mmRevealObserver) {
      window.mmRevealObserver = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (!entry.isIntersecting) return;
            entry.target.classList.add('is-visible');
            window.mmRevealObserver.unobserve(entry.target);
          });
        },
        { threshold: 0.12, rootMargin: '0px 0px -7% 0px' }
      );
    }

    if (!window.mmMaskRevealObserver) {
      window.mmMaskRevealTargets = new Map();
      window.mmMaskRevealObserver = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (!entry.isIntersecting) return;

            const targets = window.mmMaskRevealTargets.get(entry.target);
            targets?.forEach((target) => target.classList.add('is-visible'));
            window.mmMaskRevealTargets.delete(entry.target);
            window.mmMaskRevealObserver.unobserve(entry.target);
          });
        },
        { threshold: 0.08, rootMargin: '0px 0px -7% 0px' }
      );
    }

    revealItems.forEach((item) => {
      if (item.dataset.mmObserved === 'true') return;
      item.dataset.mmObserved = 'true';

      if (item.classList.contains('mm-reveal--mask') && item.parentElement) {
        const anchor = item.parentElement;
        const targets = window.mmMaskRevealTargets.get(anchor) || new Set();
        targets.add(item);
        window.mmMaskRevealTargets.set(anchor, targets);
        window.mmMaskRevealObserver.observe(anchor);
        return;
      }

      window.mmRevealObserver.observe(item);
    });
  };

  const bindHeroLight = () => {
    const hero = document.querySelector('[data-mm-hero]');
    if (!hero || hero.dataset.mmPointerBound === 'true' || reduceMotion.matches || !finePointer.matches) return;

    hero.dataset.mmPointerBound = 'true';
    let pointerFrame = 0;
    let pointerX = 70;
    let pointerY = 35;

    hero.addEventListener('pointermove', (event) => {
      const bounds = hero.getBoundingClientRect();
      pointerX = ((event.clientX - bounds.left) / bounds.width) * 100;
      pointerY = ((event.clientY - bounds.top) / bounds.height) * 100;
      if (pointerFrame) return;

      pointerFrame = window.requestAnimationFrame(() => {
        hero.style.setProperty('--mm-pointer-x', `${pointerX}%`);
        hero.style.setProperty('--mm-pointer-y', `${pointerY}%`);
        pointerFrame = 0;
      });
    });
  };

  const updateScroll = () => {
    document.body.classList.toggle('mm-header-scrolled', window.scrollY > 24);

    if (!reduceMotion.matches) {
      document.querySelectorAll('[data-mm-parallax]').forEach((item) => {
        const rect = item.parentElement.getBoundingClientRect();
        const viewport = window.innerHeight || 1;
        const progress = Math.max(-1, Math.min(1, (viewport - rect.top) / (viewport + rect.height) - 0.5));
        item.style.setProperty('--mm-parallax-y', `${progress * 18}px`);
      });
    }

    window.mmLandingTicking = false;
  };

  const bindScroll = () => {
    if (window.mmLandingScrollBound) return;
    window.mmLandingScrollBound = true;

    window.addEventListener(
      'scroll',
      () => {
        if (window.mmLandingTicking) return;
        window.mmLandingTicking = true;
        window.requestAnimationFrame(updateScroll);
      },
      { passive: true }
    );
  };

  const initMymori = () => {
    const hasLandingHero = document.querySelector('[data-mm-hero]');

    if (hasLandingHero) {
      document.body.classList.add('mm-landing-page');
    }

    setRevealDelays();
    observeReveals();
    bindHeroLight();
    bindScroll();
    updateScroll();
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initMymori, { once: true });
  } else {
    initMymori();
  }

  document.addEventListener('shopify:section:load', initMymori);
})();
